import React from 'react';

function PageNotFound() {
  return (
    <section id="page-not_found" className="text-center mt-20">
      <h2 className="text-5xl md:text-7xl font-medium">
        404
      </h2>
      <p className="md:text-xl font-bold">
        Page not found
      </p>
    </section>
  );
}

export default PageNotFound;
